(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7561],{

/***/ 20276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ SharingLinks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/Global/index.js + 5 modules
var Global = __webpack_require__(25330);
;// CONCATENATED MODULE: ./src/components/SocialSharing/SharingLinks/SharingLinks.jsx




var SharingLinks = function(param) {
    var className = param.className, buttonClassName = param.buttonClassName, _appearance = param.appearance, appearance = _appearance === void 0 ? "dark" : _appearance;
    var socialSharingLinks = (0,Global/* useGlobalState */.j1)().socialSharingLinks;
    var ref = (0,react.useState)(null), currentUrl = ref[0], setCurrentUrl = ref[1];
    (0,react.useEffect)(function() {
        if (true) {
            setCurrentUrl(window.location.href);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: className,
        children: socialSharingLinks.map(function(param) {
            var title = param.title, href = param.href, icon = param.icon;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                as: "a",
                htmlAttributes: {
                    href: "".concat(href).concat(currentUrl),
                    title: title,
                    target: "_blank"
                },
                icon: icon,
                className: buttonClassName,
                appearance: "outlined",
                theme: appearance,
                hover: appearance === "dark" ? "fill" : "reverse"
            }, "".concat(title, "_").concat(href, "_").concat(icon));
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SocialSharing/SharingLinks/index.js



/***/ }),

/***/ 47561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutWidget031": function() { return /* binding */ LayoutWidget031; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93590);
/* harmony import */ var components_SocialSharing_SharingLinks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20276);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91929);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52853);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65202);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87367);
/* harmony import */ var _LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80305);
/* harmony import */ var _LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12__);














var LayoutWidget031 = function(param) {
    var payload = param.payload;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)().t;
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_5__/* .buildWidgetInstanceId */ .G1)("l031", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_6__/* .WIDGETS_REGISTRY["LAYOUT-WIDGET"] */ .R["LAYOUT-WIDGET"]);
    var events = (0,shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_9__/* .useCollectedData */ .M)(instanceId, [
        {
            name: "events",
            defaultValue: []
        }, 
    ]).events;
    var ref6 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useToggle */ .OT)(), opened = ref6.opened, onOpen = ref6.onOpen, onClose = ref6.onClose;
    var _events = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(events, 1), event = _events[0];
    var ref7, _eventPlace;
    var eventPlace = "".concat((ref7 = t(event.eventType)) !== null && ref7 !== void 0 ? ref7 : "", ", ").concat((_eventPlace = event.eventPlace) !== null && _eventPlace !== void 0 ? _eventPlace : "");
    var ref8;
    var eventCategoryTitle = (ref8 = (ref = event.eventCategories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref8 !== void 0 ? ref8 : "";
    var ref9;
    var requestType = (ref9 = (ref2 = event.request) === null || ref2 === void 0 ? void 0 : ref2.type) !== null && ref9 !== void 0 ? ref9 : "form";
    var ref10;
    var form = (ref10 = event === null || event === void 0 ? void 0 : (ref3 = event.request) === null || ref3 === void 0 ? void 0 : ref3.form) !== null && ref10 !== void 0 ? ref10 : {};
    var ref11;
    var buttonText = (ref11 = (ref4 = event.request) === null || ref4 === void 0 ? void 0 : ref4.buttonText) !== null && ref11 !== void 0 ? ref11 : "";
    var ref12;
    var requestLink = (ref12 = (ref5 = event.request) === null || ref5 === void 0 ? void 0 : ref5.link) !== null && ref12 !== void 0 ? ref12 : "";
    var ref13;
    var active = (ref13 = event === null || event === void 0 ? void 0 : event.active) !== null && ref13 !== void 0 ? ref13 : false;
    var ref14;
    var ticketsLeft = (ref14 = event === null || event === void 0 ? void 0 : event.ticketsLeft) !== null && ref14 !== void 0 ? ref14 : null;
    var ref15;
    var tickets = (ref15 = event === null || event === void 0 ? void 0 : event.tickets) !== null && ref15 !== void 0 ? ref15 : false;
    var currentButtonText = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        return active ? buttonText : t("event_finished");
    }, [
        active,
        buttonText,
        t
    ]);
    if (events.length === 0) {
        return null;
    }
    var items = [
        {
            id: "date",
            label: t("date"),
            text: event.eventTimeDescription
        },
        {
            id: "time",
            label: t("time"),
            text: event.eventDuration
        },
        {
            id: "price",
            label: t("price"),
            text: event.eventPrice
        },
        {
            id: "place",
            label: t("place"),
            text: eventPlace
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().top),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Paragraph */ .nv, {
                            className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().category),
                            color: "brand",
                            appearance: "bold",
                            uppercase: true,
                            children: eventCategoryTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().block),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Heading4 */ .k8, {
                                    className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().headline),
                                    color: "dark",
                                    children: event.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().details),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .DetailsBlock */ .IR, {
                                            items: items,
                                            className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().event)
                                        }),
                                        tickets && ticketsLeft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().tickets),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Paragraph */ .nv, {
                                                    color: "grey",
                                                    uppercase: true,
                                                    children: t("tickets_left")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Paragraph */ .nv, {
                                                    color: "dark",
                                                    appearance: "bold",
                                                    children: ticketsLeft
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().block),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().sharing),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Paragraph */ .nv, {
                                            color: "grey",
                                            children: [
                                                t("share"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SocialSharing_SharingLinks__WEBPACK_IMPORTED_MODULE_3__/* .SharingLinks */ ._, {
                                            appearance: "brand",
                                            className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().social),
                                            buttonClassName: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().button)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["button-wrap"]),
                                    children: requestType === "form" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Action */ .aU, {
                                        onClick: onOpen,
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().play), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().disabled), !active || ticketsLeft === 0)),
                                        disabled: !active || ticketsLeft === 0,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Paragraph */ .nv, {
                                                className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().label),
                                                appearance: "bold",
                                                color: "light",
                                                uppercase: true,
                                                children: currentButtonText
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().arrow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO, {
                                                    className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().icon),
                                                    name: "arrow_right"
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .PageLink */ .H_, {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().play), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().disabled), !active)),
                                        link: requestLink,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Paragraph */ .nv, {
                                                className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().label),
                                                appearance: "bold",
                                                color: "light",
                                                uppercase: true,
                                                children: currentButtonText
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().arrow),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO, {
                                                    className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().icon),
                                                    name: "arrow_right"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .ModalWrapper */ .AB, {
                                    onCloseModal: onClose,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                                        item: form,
                                        metaData: {
                                            type: "event",
                                            id: event.id
                                        },
                                        instanceId: instanceId,
                                        info: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_2__/* .FormInfo */ .Nf, {
                                            title: event.title,
                                            date: event.eventTimeDescription
                                        }),
                                        onReset: onClose
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_8__/* .ImageLite */ .NH, {
                    image: event.previewImage,
                    className: (_LayoutWidget031_module_scss__WEBPACK_IMPORTED_MODULE_12___default().image)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LayoutWidget031);


/***/ }),

/***/ 80305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget031_wrapper__dS3zY","top":"LayoutWidget031_top__Z_YI_","headline":"LayoutWidget031_headline__Buz3T","category":"LayoutWidget031_category__9KSaL","block":"LayoutWidget031_block__4v_G3","details":"LayoutWidget031_details__k9Qwh","event":"LayoutWidget031_event__ZZ2FX","tickets":"LayoutWidget031_tickets__Lc7e9","sharing":"LayoutWidget031_sharing__YAl_Q","social":"LayoutWidget031_social__rhRuw","button":"LayoutWidget031_button__rCmLC","label":"LayoutWidget031_label__BZL9X","button-wrap":"LayoutWidget031_button-wrap__p0a7z","play":"LayoutWidget031_play__UWGKG","disabled":"LayoutWidget031_disabled__7U7nG","arrow":"LayoutWidget031_arrow__cXACa","icon":"LayoutWidget031_icon__T1UvI","image":"LayoutWidget031_image__8TBJ_"};

/***/ })

}]);